import React from "react";
import { connect } from "react-redux";
import { isUserLoaded } from "../../helpers/status";
import { checkAuthStatus } from "../../reducers/user/actions";
import { AppState } from "../../store";

const mapState = (state: AppState) => ({ status: state.status });
const mapDispatch = { checkAuthStatus };

type StateProps = ReturnType<typeof mapState>;
type DispatchProps = typeof mapDispatch;
type OwnProps = {
    children: JSX.Element | JSX.Element[];
};
type Props = StateProps & DispatchProps & OwnProps;

class AppUser extends React.Component<Props> {
    componentDidMount() {
        this.props.checkAuthStatus(null);
    }

    render() {
        if (!isUserLoaded(this.props.status)) {
            return null;
        }

        return this.props.children;
    }
}

export default connect(mapState, mapDispatch)(AppUser);
